<template>
	<div>
		<h1 class="advantage-title">资质认证</h1>
		<div class="title-remark">双创人才大数据平台将大数据应用于双创人才服务全过程，功能完备、创新引领，是服务创新创业人才的重要支撑和引领产业转型升级的关键力量。</div>
		<el-row class="row" type="flex" justify="space-between">
		  <el-col :span="10" class="item">
			<div class="item-title">1.窗口+平台，流量优势</div>
			<div class="item-remark">依托人才服务窗口，就近为人才双创提供各类服务，为平台导入人才数据流量；充分利用平台10个分类数据库的数据资源，提高创新创业服务和资源融通的质量与效率。</div>
		  </el-col>
		  <el-col :span="10" class="item">
			<div class="item-title">2.专家+机构，服务优势</div>
			<div class="item-remark">柔性引进资深行业专家，线上合作专业服务机构，构建“平台共建、资源共享、合作共赢”的人才服务体系，为企业提供专业高效的各类双创服务。</div>
		  </el-col>
		</el-row>
		<el-row class="row" type="flex" justify="space-between">
		  <el-col :span="10" class="item">
			<div class="item-title">3.本地+外地，资源优势</div>
			<div class="item-remark">整合集聚本地双创、人才信息数据资源，链接外地高端人才、服务资源，不断拓展高端服务领域，形成“上下贯通、左右连通、内外融通”的发展局面，满足人才企业个性化服务需求。</div>
		  </el-col>
		  <el-col :span="10" class="item">
			<div class="item-title">4.公益+付费，成本优势</div>
			<div class="item-remark">根据人才创新创业过程中遇到的痛点，为人才提供涵盖27项公益服务、18项付费服务内容，实现信息一站式查询、服务一站式提供、诉求一站式响应，降低人才企业的沟通成本、交流成本、交易成本、信用成本及管理运营成本。</div>
		  </el-col>
		</el-row>
		<el-row class="row" type="flex" justify="space-between">
		  <el-col :span="10" class="item">
			<div class="item-title">5.便捷+必应，平台优势</div>
			<div class="item-remark">足不出户，即享服务，真正实现“数据多跑路，客户少跑腿”；及时跟进企业需求，做到有求必应，同时加强数据管理，做到无事不扰。</div>
		  </el-col>
		</el-row>
	</div>
</template>

<script>
export default {
	name: 'advantage',
	data() {		
		return {			
		};
	},
	methods: {
	}
};
</script>

<style lang="scss" scoped>
.advantage-title{
	color: rgba(73, 149, 223, 100);
	font-size: 20px;
	font-weight: bold;
	text-align: center;
}
.title-remark{
	text-align: center;
	margin-top: 15px;
	margin-bottom: 60px;
}
.row{
	margin: 0px 52px 0px 52px;
}
.item{
	.item-title{
		color: rgba(73, 149, 223, 100);
		font-size: 18px;
		font-weight: bold;
	}
	.item-remark{
		padding:15px 0px 15px 0px;
		line-height: 24px;
		text-align: justify;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/advantage.vue